/**
 * Dropdown Viewport Fix for Focal Theme
 * Stellt sicher, dass alle Dropdown-Menüs immer im Viewport bleiben
 */

(function() {
  'use strict';

  function adjustDropdownPosition(dropdown) {
    if (!dropdown || !dropdown.classList.contains('nav-dropdown')) {
      return;
    }

    requestAnimationFrame(() => {
      const rect = dropdown.getBoundingClientRect();
      const viewportWidth = window.innerWidth;
      
      // Wenn das Dropdown rechts rausläuft
      if (rect.right > viewportWidth) {
        const overflow = rect.right - viewportWidth;
        
        // Ist es ein erstes Level Dropdown (direkt unter header)?
        const isFirstLevel = dropdown.parentElement.classList.contains('header__linklist-item');
        
        if (isFirstLevel) {
          // Erstes Level: verschiebe es nach links
          const currentLeft = dropdown.offsetLeft;
          dropdown.style.left = (currentLeft - overflow - 20) + 'px';
        } else {
          // Verschachteltes Level: öffne nach links
          dropdown.classList.add('nav-dropdown--left');
        }
      }
      
      // Wenn das Dropdown links rausläuft (nach Korrektur)
      const newRect = dropdown.getBoundingClientRect();
      if (newRect.left < 0) {
        dropdown.style.left = '20px';
      }
    });
  }

  // Bei Dropdown-Öffnung Position anpassen
  document.addEventListener('DOMContentLoaded', function() {
    const desktopNav = document.querySelector('desktop-navigation');
    if (!desktopNav) return;

    // Observer für alle Dropdown-Änderungen
    const observer = new MutationObserver(function(mutations) {
      mutations.forEach(function(mutation) {
        if (mutation.type === 'attributes' && mutation.attributeName === 'hidden') {
          const dropdown = mutation.target;
          if (dropdown.classList.contains('nav-dropdown') && !dropdown.hasAttribute('hidden')) {
            adjustDropdownPosition(dropdown);
          }
        }
      });
    });

    observer.observe(desktopNav, {
      attributes: true,
      subtree: true,
      attributeFilter: ['hidden']
    });

    // Auch bei Resize anpassen
    let resizeTimeout;
    window.addEventListener('resize', function() {
      clearTimeout(resizeTimeout);
      resizeTimeout = setTimeout(function() {
        const openDropdowns = desktopNav.querySelectorAll('.nav-dropdown:not([hidden])');
        openDropdowns.forEach(adjustDropdownPosition);
      }, 100);
    });
  });
})();